import {Injectable} from '@angular/core';
import { Message } from '../class/message';
import { CommonService } from './common.service';
import { ContractService } from './contract.service';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';

declare let gtag: (...args: any[]) => void;

@Injectable({
  providedIn: 'root'
})

export class AnalyticService {
    constructor(
        private apiService: ApiService,
        private toastr: ToastrService,
        private contractService: ContractService,
        private commonService: CommonService,
        public message: Message
    ){

    }
    getGaMeasurementId(){
        return this.apiService.post(`/common/app-param`, {code : 'google_analytics_id'}).pipe(map(res => {
          return res;
        }));
    }
    
    public sendEvent(eventName: string, eventParams?: any) {
        gtag('event', eventName, eventParams);
    }

    public sendPageView(pagePath: string, id: string) {
        gtag('config', id, { page_path: pagePath , page_title: document.title});
    }

    loadGoogleAnalytics(measurementId: string) {
        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        document.head.appendChild(script1);
    
        const script2 = document.createElement('script');
        script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}');
        `;
        document.head.appendChild(script2);
      }
}